import { Box, DateField } from '@flos/react-ui';
import StringParagraph from './StringParagraph';
import StringTitle from './StringTitle';
import { convertLocalDateDTOToDate } from '../../../utils/dateUtil';
import { useHippoText } from '../../../hooks/useHippoText';
import type { CoverableDTO } from 'gw-edge-client/dist/types/dto/pc/top/edge/capabilities/onlinesales/dto/quote';

export const EDICancellationExternalCaseCarTilgang = ({
    car
}: {
    car: CoverableDTO;
}): React.JSX.Element => {
    const getHippoText = useHippoText();
    return (
        <Box className="cancellationCaseBox">
            <StringTitle>{String(car.flavourName)}</StringTitle>
            <StringParagraph className={'h6 u-color-secondary-4-medium'}>
                {car.name}
            </StringParagraph>
            <DateField
                selected={
                    car.effectiveDate ? convertLocalDateDTOToDate(car.effectiveDate) : undefined
                }
                label="Startdato"
                id={`no-datefield-${String(car.fixedId)}`}
                dateFormat="dd. MMMM yyyy"
                disabled
            />
            <StringParagraph small>
                {getHippoText('DSS-EFFECTIVE-DATE-AND-CANCELLATION-CAR-TILGANG-RECEIVED-LOCKED')}
            </StringParagraph>
        </Box>
    );
};
